import type { JSONSchemaType, ValidateFunction } from 'ajv'
import { ajv, isValidThing } from '../ajv'

export type CheckPoint = {
  id: number
  auditPointId: number
  checkPointNo: string
  translationGuid: string
  note: string | null
  score: boolean | null
  sortOrder: number
}

export type CheckPointNumber = Pick<CheckPoint, 'id' | 'checkPointNo'>
export type CheckPointNumberJson = { id: number; checkPointNo: string }

export const CheckPointNumberSchema: JSONSchemaType<CheckPointNumberJson> = {
  type: 'object',
  properties: {
    id: { type: 'integer' },
    checkPointNo: { type: 'string' }
  },
  required: ['id', 'checkPointNo']
}

export const CheckPointNumbersSchema: JSONSchemaType<CheckPointNumberJson[]> = {
  type: 'array',
  items: CheckPointNumberSchema
}

export const CheckPointSchema: JSONSchemaType<CheckPoint> = {
  type: 'object',
  properties: {
    id: {
      type: 'integer'
    },
    auditPointId: {
      type: 'integer'
    },
    checkPointNo: {
      type: 'string'
    },
    translationGuid: {
      type: 'string'
    },
    note: {
      type: 'string',
      nullable: true
    },
    score: {
      type: 'boolean',
      nullable: true
    },
    sortOrder: {
      type: 'integer'
    }
  },

  required: [
    'id',
    'auditPointId',
    'checkPointNo',
    'translationGuid',
    'note',
    'score',
    'sortOrder'
  ]
}

const validateCheckPoint: ValidateFunction<CheckPoint> =
  ajv.compile(CheckPointSchema)

export const isValidCheckPoint = (
  checkPoint: unknown
): checkPoint is CheckPoint =>
  isValidThing<CheckPoint>(checkPoint, validateCheckPoint)

const validateCheckPointNumber: ValidateFunction<CheckPointNumberJson> =
  ajv.compile(CheckPointNumberSchema)

export const isValidCheckPointNumber = (
  data: unknown
): data is CheckPointNumberJson =>
  isValidThing<CheckPointNumberJson>(data, validateCheckPointNumber)

const validateCheckPointNumbers: ValidateFunction<CheckPointNumberJson[]> =
  ajv.compile(CheckPointNumbersSchema)

export const isValidCheckPointNumbers = (
  data: unknown
): data is CheckPointNumberJson[] =>
  isValidThing<CheckPointNumberJson[]>(data, validateCheckPointNumbers)
